/* Casa Lizette — global UI wiring (mobile nav, header state). Vanilla JS, no dependencies. */
(function () {
  'use strict';

  function initMobileNav() {
    var toggle = document.querySelector('[data-mobile-nav-toggle]');
    var close = document.querySelector('[data-mobile-nav-close]');
    var nav = document.querySelector('[data-mobile-nav]');
    if (!toggle || !nav) return;

    function open() {
      nav.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      toggle.setAttribute('aria-expanded', 'true');
    }
    function closeNav() {
      nav.classList.remove('is-open');
      document.body.style.overflow = '';
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', open);
    if (close) close.addEventListener('click', closeNav);
    nav.addEventListener('click', function (e) {
      if (e.target === nav) closeNav();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeNav();
    });
  }

  function initHeaderScrollState() {
    var header = document.querySelector('[data-site-header]');
    if (!header) return;
    var lastY = window.scrollY;

    function onScroll() {
      var y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 8);
      lastY = y;
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function initAnnouncementBar() {
    var bar = document.querySelector('[data-announcement-bar][data-autoplay]');
    if (!bar) return;
    var messages = bar.querySelectorAll('.announcement-bar__message');
    if (messages.length < 2) return;
    var interval = (parseInt(bar.getAttribute('data-interval'), 10) || 5) * 1000;
    var index = 0;

    setInterval(function () {
      messages[index].hidden = true;
      index = (index + 1) % messages.length;
      messages[index].hidden = false;
    }, interval);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMobileNav();
    initHeaderScrollState();
    initAnnouncementBar();
  });
})();
